import axios from 'axios';

import { ACCOUNT_TRIALS } from 'RestAPIs/endpoints';

export enum TrialType {
  EMBEDDED_ANALYTICS = 'EMBEDDED_ANALYTICS'
}

type AccountTrialStatusResponse = {
  accountId: number;
  type: TrialType;
  isStarted: boolean;
  expiresOn: any;
  numberOfDaysLeft: number;
};

type BuyPayload = {
  email: string;
  type: TrialType.EMBEDDED_ANALYTICS;
};

export type AccountTrialRequest = {
  type: TrialType;
};

export const getAccountTrialStatus = (type: TrialType) =>
  axios.get<AccountTrialStatusResponse>(`${ACCOUNT_TRIALS}/${type}`);

export const createAccountTrial = (type: TrialType) =>
  axios.post(ACCOUNT_TRIALS, { type });

export const trialBuy = (body: BuyPayload) =>
  axios.post(`${ACCOUNT_TRIALS}/buy`, { ...body });
